<template>
    <div>
        <div :class="resolucion()">
            <spiner v-show="loading"></spiner>
            <h6 v-show="loading" class="text-center text-muted text-cargando"> Cargando contenido...</h6> 
        </div>
        <!-- <div v-if="!data" class="text-center" style="margin: 7rem auto">
            <div class="spinner-grow spinner-grow-sm text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <h6 class="text-muted"> Cargando contenido...</h6>
        </div> -->  


        <div  v-show="!loading" class="bg-light px-5 py-5 mt-5  hacienda-padre" style="border-top-right-radius:10px;">
            <!-- <atras-component></atras-component> -->
            <div class="row">
                <!-- Datos del padre (Secretaria de hacienda) -->
                <div v-if="data" class="">
                    <div class="hacienda">
                        <h3 class="subtitulo">{{data.organopadre.dependencia.Organo}}</h3>
                        <p>{{data.organopadre.dependencia.domicilio}} <br>
                        {{data.organopadre.dependencia.colonia}} C.P. {{data.organopadre.dependencia.cp}} {{data.organopadre.dependencia.cp}} {{data.organopadre.dependencia.municipio}}, Chiapas  <br>
                        Conmutador: {{data.organopadre.dependencia.conmutador}} <br>
                        <a href="">{{data.organopadre.dependencia.web}}</a></p>
                    </div>
                    <hr>
                    <div class="secretario">
                        <h3 class="subtitulo2">{{data.organopadre.encargado.funcionario}}</h3>
                        <p>{{data.organopadre.encargado.organo}}<br>
                            Conmutador: {{data.organopadre.encargado.conmutador}} <br>
                        Correo: {{data.organopadre.encargado.correo}}</p>
                    </div>
                </div>
                <!-- Area para seleccionar un organo hijo de Hacienda -->
                <div class="col-12 cards-hacienda d-flex my-4 px-0">
                    <div class="col-8 padding-left pl-0">
                        <select class="js-example-basic-single custom-select custom-select-lg" id="miCombo"></select>
                    </div>
                    <div class="col-4 padding-right">
                        <button @click="obtenerNieto" class="btn btn-vino btn-block" style="padding:.5rem; height:100%;">Consultar</button>
                    </div>
                </div>
            </div>
        </div>          
        
        <div v-if="verCollapse">
            <!-- Ciclo solo para mostrar los datos del hijo de Hacienda seleccionado -->
            <div v-for="hijo in data.organoshijos[0][nombreHijo]"> <!---Seleccionar  el objeto donde se encuentre el otro objeto con el organo hijo que se selecciono en el select por medio de su NUMERO DE INDICE ---->
                <div v-if="hijo.IDPadre === 43"> <!----Seleccionar el organo que su padre directo sea hacienda, sin esta condición me imprime los demás objetos vacios que tienen los nietos de Hacienda----->
                    <!-- Datos del hijo de Hacienda seleccionado -->
                    <div v-if="hijo.Funcionario != null">
                        <div class="datos_hijo">
                            <p style="color: #560f2c; font-size: 18px;">{{hijo.Organo}}</p>
                            <p style="font-weight:bolder;">{{hijo.Funcionario}}</p>
                            <p>{{hijo.conmutador}}</p>
                            <p>{{hijo.Correo}}</p>
                            <p>{{hijo.domicilio}} {{hijo.colonia}} C.P. {{hijo.cp}} {{hijo.municipio}} </p>
                        </div>
                        <h1 class="OrganoTitulo">Direcciones que pertenecen a este Órgano Administrativo:</h1>
                    </div>
                    <div v-else>
                        <h1 class="OrganoTitulo">{{hijo.Organo}}</h1>
                    </div>
                </div>                
            </div>
             <!-- Ciclo para mostrar nietos y bisnietos de hacienda -->                
            <div v-for="(organos_hijos, a) in data.organoshijos[0][nombreHijo] " :key="a">
                <div v-for="(nieto, b) in organos_hijos" :key="b">
                    <div v-if="nieto">
                        <!-- seccion collapses -->
                    <div class="container my-4">
                        <div v-show="b== nieto.nombredependencia">
                            <div class="accordion mt-4" id="accordionExample">
                                <div class="card card-padre">
                                    <div class="card-header" :id="'heading'+a" style="/*background: #f0f0f0;*/">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" :data-target="'#collapse'+a+1" aria-expanded="true" :aria-controls="'collapse'+a+1" style="display:flex; justify-content:space-between;">
                                            <span>{{nieto.nombredependencia}} </span>
                                            <span class="descargar" style="font-size:1.5rem;"><i class='bx bx-chevron-down icono-down' style="color: #560f2c;"></i></span>
                                            </button>
                                        </h2>
                                    </div>
                                    <div :id="'collapse'+a+1" class="collapse" :aria-labelledby="'heading'+a" data-parent="#accordionExample">
                                        <div class="card-body">
                                            <!-- datos del organismo nieto -->
                                            <p> <b>{{nieto.funcionario}}</b></p>
                                            <p> {{nieto.conmutador}} - {{nieto.correo}} </p>
                                            <p> {{nieto.domicilio}} {{nieto.colonia}} C.P. {{nieto.cp}} {{nieto.municipio}} </p>

                                            <div style="width:100%; border-bottom: .1rem dashed #ce232345; margin-top: .8rem;"></div>
                                            <div v-for="(v1, v) in nieto.departamentos" :key="v">
                                                <div class="cards-estilos">
                                                    <div v-for="(bisnietos, b) in v1" :key="b">
                                                        <div class="card text-dark cards-st" style="max-width: 18rem;">
                                                            <div class="card-header  bg-light">{{bisnietos.Organo}}</div>
                                                            <div class="card-body estilos-p" >
                                                                <!-- Datos del organo bisnieto -->
                                                                <p>{{bisnietos.Funcionario}}</p>
                                                                <p>{{bisnietos.domicilio}} {{bisnietos.colonia}} C.P. {{bisnietos.cp}} {{bisnietos.municipio}}, Chiapas</p>
                                                                <p>{{bisnietos.conmutador}}</p>
                                                                <p>{{bisnietos.Correo}}</p>
                                                            </div>
                                                        </div>
                                                    </div>                                                        
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                                
                                </div>               
                            </div>

                        </div>
                                        
                    </div>

                    </div>
                </div>

                
            </div>
           

            
        </div>

    </div>
</template>
<script>
import axios from "axios";
import Api from "../../../services/config/api/axios.urlcontext"
import spiner from './../../spiner.vue'
import atrasComponent from './../../reload'
export default {
    components:{
        spiner,
        atrasComponent
    },
    data:function() {
        return{
            jsonFuncionario: Api.APP_URL_API + '/Otros-Recursos/unidadTecnica.json',
            resfuncionario: null,

            //servicio local
            //jsonDirectorio: 'http://172.28.8.107/funcionarios-api/funcionarios/dependencia/43',   //this.$urlServidor + 'funcionarios-api/funcionarios/dependencia/43',      //
            
            //servicio
            jsonDirectorio: 'https://api.chiapas.gob.mx/funcionarios/dependencia/43',
           
            UrlServer: '',
            data: null,
            nombreHijo: '',
            verCollapse: false,
            loading: true,
            organo: null,
        }
    },
    created: function(){
            this.consultaDirectorioOrgano();
            this.funcionario_elegido();
        },
    mounted() {
        window.scrollTo(0, 0);
    },
    methods:{

        idOrgano(valor){
            this.organo = valor;
        },

        proceso(_combo){
            var listaOrganosHijo = this.data.organoshijos[0]
            // console.log("hola desde el metodo llenadoSelect", listaOrganosHijo, idSelect, this.loading);
            $("#"+_combo).empty();
            $("#"+_combo).append("<option hidden selected>Seleccione un Órgano Administrativo</option>");
            $.each(listaOrganosHijo, function (indice, row) {  
                // console.log("esto", row) 
                $.each(row, function(j, organo){
                    if(organo.IDPadre == 43){
                        // console.log(indice);
                        $("#" + _combo).append("<option value='" + indice + "'>" + organo.Organo + "</option>");
                    }
                 });
            });
        },
        consultaDirectorioOrgano(){
             axios
            .get(this.jsonDirectorio)
            .then((res) => {
                this.data = res.data
                this.loading = false
                this.proceso('miCombo');              
                
            })
        },


        obtenerNieto(){
            this.verCollapse = true;
            this.nombreHijo = document.getElementById('miCombo').value;
            // console.log("esto", this.nombreHijo);
        },

        //|----------------------------------------------|\\
        //| ---- pruebas para busqda por funcionario ----|\\
        //|----------------------------------------------|\\
        funcionario_elegido(){
            axios.get(this.jsonFuncionario)
            .then(response => {
                this.resfuncionario = response.data;
                // console.log(this.resfuncionario);
            })
            .catch(function (error) {
                console.log('____', error);
            });
        },
        resolucion(){ if(screen.width > 1900 && !this.data){ return "spinner_margin"; }
        },  

    },
       
}
</script>

<style scoped>
.text-cargando{
    margin-bottom: 6rem;
}

.cards-hacienda .card{
    background-color: transparent !important;
    border: 0 !important;
}

.hacienda-padre{
    width:100%;
    height:50%;
     /* background-image: url("@/imagenes/banerrojo.png") !important; */
    /* border: 1px solid #ededed; */
    padding-bottom: 0 !important;
}



.subtitulo{
    font-size: 1.5rem !important;
    color: #545151;
    margin-top: 1.6rem !important;
}

.subtitulo2{ font-size: 1.2rem; margin-bottom: 0 !important;}

.hacienda p, .secretario p {
    margin-bottom: .3rem;
    /* text-align: center; */
    font-size: 1rem;
    font-weight: 300;
}
.datos_hijo{
    background-color: #f8f9fa;
    padding: 0 1.5rem 1.5rem 2rem;
}
.datos_hijo p{
 margin-bottom: 0rem   
}
    
/* ------------- */
.OrganoTitulo{
    font-size: 1.5rem;
    font-weight: 300;
    color:#fff;
    background: #702544de;
    padding: 1rem;
    border-bottom-right-radius: 22px;
}
.subtitulo2 { color: #545151; }
.card-header { background-color: #fff; }
.btn-link{ 
    color: #560f2c;
    font-size: 18px;
    letter-spacing: .3px;
}
.btn:focus { box-shadow: none; }
.btn-link:hover { text-decoration: none; }

.btn{ padding: 0 !important;}

.cards-estilos{
    display: flex;
    flex-wrap: wrap;
}
.cards-st{ 
    margin: 1rem;
    max-width: 18rem;
    min-height: 20rem;    
 }
.card-padre{
    border: 1px solid #fff ;
    border-bottom: 1px solid #cbcbcb78 !important;
    border-radius: 0 !important;
    
}

li{ 
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }


/*  */

    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

   
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
        margin-top: 3rem;
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex !important;
        justify-content: flex-end !important;
    }
    .card-width{ width: 90%; }
    
    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }
    .card-body p{
    margin-bottom: 0.1rem !important; /***aqui */
    }
    .estilos-p{ font-size: 14px; }

@media only screen and (max-device-width : 900px) {

    .custom-select-lg{
        padding-left: 0;
        font-size: .8rem;
    }
    .padding-right{ padding-right: 0 !important; }
    .padding-left{ padding-left: 0 !important; }

    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around !important; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
        .cards-st{
        margin: .5rem 0;
        
        width: 17rem;
        height: 21rem; 
    }
}

/* --------------------------------- */
/* --------------------------------- */



</style>
